import { MealsService } from '@/backend/market'
import { LiveMealRepository } from '../../domain/repositories/LiveMealRepository'
import type { LiveMealFilterEntity } from '../../domain/entities/LiveMealFilterEntity'
import { LiveMealFilterModel } from '../models/LiveMealFilterModel'
import { LiveMealResponseModel } from '../models/LiveMealResponseModel'

import { LiveMealStreamV2ResponseModel } from '../models/LiveMealStreamV2ResponseModel'
import type { GetMealsCountByStatusAdminResponse } from '@/backend/market'

export class LiveMealRepositoryImpl implements LiveMealRepository {
  async getLiveMealStreamV2(
    filterData: LiveMealFilterEntity
  ): Promise<LiveMealStreamV2ResponseModel | { error: true }> {
    try {
      const filterModel = new LiveMealFilterModel(filterData)
      const response = await MealsService.getMealStreamsV2Admin(filterModel)
      return new LiveMealStreamV2ResponseModel(response)
    } catch (e) {
      return { error: true }
    }
  }

  async getMealsCountByStatus(
    filterData: LiveMealFilterEntity
  ): Promise<GetMealsCountByStatusAdminResponse | { error: true }> {
    const filterModel = new LiveMealFilterModel(filterData)
    try {
      return await MealsService.getMealsCountByStatusAdmin(filterModel)
    } catch {
      return { error: true }
    }
  }

  async getLiveMeal(
    filterData: LiveMealFilterEntity
  ): Promise<LiveMealResponseModel | { error: true }> {
    const filterModel = new LiveMealFilterModel(filterData)
    try {
      const response = await MealsService.getMealStreamsAdmin(filterModel)
      const liveMealResponseModel = new LiveMealResponseModel(response)

      return liveMealResponseModel
    } catch {
      return { error: true }
    }
  }
  async watchMeal(mealId: string): Promise<{ success: true } | { error: true }> {
    try {
      await MealsService.postMealTrackingAdmin({ id: mealId })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
